:host {
  display: flex;
  flex-direction: column;
  gap: var(--pine-dimension-sm);
}

:host(.is-invalid) {
  .pds-radio-group__message--error {
    color: var(--pine-color-text-message-danger);
  }
}

.pds-radio-group__label {
  color: var(--pine-color-text-label);
  font: var(--pine-typography-heading-6);
  font-weight: var(--pine-font-weight-medium);
  letter-spacing: var(--pine-letter-spacing-heading-6);
}

.pds-radio-group__radios {
  display: flex;
  gap: var(--pds-radio-group-gap, var(--pine-dimension-xs));
}

.pds-radio-group__radios--row {
  align-items: flex-start; // Align radios to the left
  flex-direction: row;
  flex-wrap: wrap;
}

.pds-radio-group__radios--column {
  flex-direction: column;
}

.pds-radio-group__message {
  color: var(--pine-color-text-message);
  font: var(--pine-typography-body);
  width: 100%;
}

.pds-radio-group__message--error {
  display: flex;
  gap: var(--pine-dimension-2xs);

  pds-icon {
    margin-block-start: var(--pine-dimension-050);
  }
}

